import { TApplicationState } from '../../types/redux';

export function getFirstBuilder(state: TApplicationState) {
  const {
    newbuilding: { builders },
  } = state;

  if (builders && builders[0]) {
    return builders[0];
  }

  return null;
}
